import React, {Component} from 'react'
import {authenticationService} from '../../../services/AuthenticationService';

import SvGraphics from "../../../assets/SvGraphics";
import {history} from "../../../utils/history";
import * as Yup from "yup";
import validationHelper from "../../../utils/validationHelper";
import utils from "../../../utils/utils";
import Error from "../../../components/single_components/Error";
import Constants from "../../../utils/constants";
import Config from "../../../config/Config";
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import ReCaptcha from "../ReCaptcha";

class LoginComposed extends Component {
    constructor(props) {
        super(props);

        if (authenticationService.currentUserValue && authenticationService.currentUserValue.profile.IsLeumitClinic !== "T") {
            this.props.history.push('/dashboard');
        }

        this.recaptchaRef = React.createRef()

        this.state = {
            username: '',
            password: '',
            auth: {},
            isErr: false,
            errMessage: '',
            errors: {},
            errorsOnSave: {},
        }
    }

    initValidation = async () => {
        let {t} = this.props
        let validationSchema = Yup.object().shape({
            username: Yup.string().min(6, t('defaults.login.username_empty_inv')).matches(Constants.emailRegExp, t('defaults.login.username_inv')).required(t('defaults.login.username_req')),
            password: Yup.string().required(t('defaults.login.pwd_req')),
            //.matches(Config.passwordRegExp,'Password must contain at least one of: a-z, A-z, 0-9 and (!,@,#,$,%,^,*,) with length of 8-20')
        })
        let errors = await validationHelper.validate(this.state.auth, validationSchema)
        await this.setState({
            validationSchema,
            errors
        })
    }

    async componentWillMount() {
        await this.initValidation()
    }

    onSubmit = async () => {
        let isLocal = process.env.REACT_APP_ENV === 'localhost'

        if (!isLocal) {
            await this.recaptchaRef.reset()
            await this.recaptchaRef.execute()
        } else {
            await this.submitData("NOTOKENINLOCAL");
        }

    }
    submitData = async (reCaptchaToken) => {
        if (!utils.isEmpty(this.state.errors)) {
            this.setState({errorsOnSave: this.state.errors});
            return;
        }
        let {username, password} = this.state
        let response = await authenticationService.login(username, password, reCaptchaToken);

        if (response.status < 400) {

            let data = response.data

            if (data.profile.Leumit_clinic === "T" && (data.role[0] === "Patient" || data.role[0] === "Doctor")) {

                await this.setUserName({target: {value: ''}})
                await this.setPassword({target: {value: ''}})
                await authenticationService.logout()

                this.setState({
                    isErr: true,
                    errMessage: response.data && response.data.message ? response.data.message : 'Wrong UserName or Password',
                })
            } else {
                if (data && data.hasOwnProperty('status') && String(data['status']).toLowerCase() === 'pass') {
                    if (data.hasOwnProperty('updatePassword') && data['updatePassword'] === true) {
                        const {from} = {from: {pathname: "/create-password"}};
                        this.props.history.push(from);
                    } else if (data.hasOwnProperty('updatePassword') && data['updatePassword'] === false) {

                        if (data['role'][0] === "Patient") {

                            let patientInfo = data
                            history.push({
                                pathname: `/PatientSelfOnboard`,
                                state: {
                                    patientInfo,
                                    from: {
                                        fromPath: `/PatientSelfOnboard`,
                                    }
                                },
                            })
                        } else {

                            const {from} = {from: {pathname: "/dashboard"}};

                            this.props.history.push(from);
                        }
                    }
                } else if (data && data.hasOwnProperty('status') && String(data['status']).toLowerCase() === '2fa') {
                    const {from} = {from: {pathname: "/2FA"}};
                    this.props.history.push(from);
                } else {
                    await this.setUserName({target: {value: ''}})
                    await this.setPassword({target: {value: ''}})
                    this.setState({
                        isErr: true,
                        errMessage: response.data && response.data.message ? response.data.message : 'No connection to server',
                    })
                }
            }

            // utils.set(data,'status','pass')
            // utils.set(data,'updatePassword',true)

        } else {
            await this.setUserName({target: {value: ''}})
            await this.setPassword({target: {value: ''}})
            this.setState({
                isErr: true,
                errMessage: response.data && response.data.message ? response.data.message : 'No connection to server',
            })
        }
    }

    setUserName = async (e) => {
        let {auth, validationSchema} = this.state
        this.setState({username: e.target.value.trim()})
        utils.set(auth, 'username', e.target.value.trim())
        let errors = await validationHelper.validate(auth, validationSchema);
        let errorsOnSave = this.state.errorsOnSave;
        if (utils.get(errorsOnSave, 'username')) {
            utils.set(errorsOnSave, 'username', utils.get(errors, 'username'))
        }
        this.setState({
            auth,
            errors,
            errorsOnSave,
            isErr: false, errMessage: ''
        })
    }

    setPassword = async (e) => {
        let {auth, validationSchema} = this.state
        this.setState({password: e.target.value.trim()})
        utils.set(auth, 'password', e.target.value.trim())
        let errors = await validationHelper.validate(auth, validationSchema);
        let errorsOnSave = this.state.errorsOnSave;
        if (utils.get(errorsOnSave, 'password')) {
            utils.set(errorsOnSave, 'password', utils.get(errors, 'password'))
        }
        this.setState({
            auth,
            errors,
            errorsOnSave,
            isErr: false, errMessage: ''
        })
    }

    resetPassword = () => {
        history.push({
            pathname: '/ResetPassword',
            state: {
                Email: this.state.username,
                from: {
                    fromPath: `/login`,
                }
            },
        })
    }

    goToRegister=()=>{
        history.push({
            pathname: '/register_recommend',
            state: {
                from: {
                    fromPath: `/login`,
                }
            },
        })
    }
    render() {
        let {t} = this.props
        return (
            <div className={"login-page"}>
                <div className={'sade-login-logo-container'}>
                    <SvGraphics svgname={'asaya_logo'} className={'sade-asaya-login-logo'}/>
                </div>
                <div className={'sade-login-main-board'}>
                    <label className={'sade-login-label-loginID'}>{t('defaults.login.login')}</label>
                    <div className={'sade-login-form-container-reg'}>
                        <div className={'sade-Pain-login-form'}>
                            <div>
                                <div className={"login-input-wrapper form-group leumit-login-form-group"}>
                                    <input className={"sade-registration-input-field"}
                                           placeholder={t('defaults.login.username')}
                                           type={"text"}
                                           name={"Username"}
                                           id={"search"}
                                           value={this.state.username}
                                           onChange={e => this.setUserName(e)}
                                           onKeyPress={event => {
                                               if (event.key === 'Enter') {
                                                   this.onSubmit()
                                               }
                                           }}/>
                                    <SvGraphics
                                        className={!!utils.get(this.state.errorsOnSave, 'username') ? "input-pic2" : "input-pic"}
                                        svgname={'person'}
                                        style={{width: '20px', height: '20px'}}/>
                                </div>

                                <Error isNonFloat={true}
                                       errorMessage={utils.get(this.state.errorsOnSave, 'username')}
                                       isShown={!!utils.get(this.state.errorsOnSave, 'username')}/>
                            </div>

                            <div>

                                <div className={"login-input-wrapper form-group leumit-login-form-group"}>
                                    <input className={"sade-registration-input-field"}
                                           placeholder={t('defaults.login.pwd')}
                                           type={"password"}
                                           name={""}
                                           value={this.state.password}
                                           onChange={e => this.setPassword(e)}
                                           onKeyPress={event => {
                                               if (event.key === 'Enter') {
                                                   this.onSubmit()
                                               }
                                           }}/>
                                    <SvGraphics
                                        className={!!utils.get(this.state.errorsOnSave, 'password') ? "input-pic2" : "input-pic"}
                                        svgname={'pass1'}
                                        style={{width: '20px', height: '20px'}}/>
                                </div>
                                <Error isNonFloat={true}
                                       errorMessage={utils.get(this.state.errorsOnSave, 'password')}
                                       isShown={!!utils.get(this.state.errorsOnSave, 'password')}/>
                            </div>


                            <div className="form-group leumit-login-form-group">
                                <button className="sade-login-form-button"
                                        onClick={this.onSubmit.bind(this)}>{t('defaults.login.login')}</button>
                            </div>

                            <div className={'sade-login-footer-container'} onClick={this.resetPassword.bind(this)}>
                                <a>{t('defaults.login.forgot_pwd')}?</a>
                            </div>

                            {/*<div className={'sade-login-footer-container'} onClick={()=>this.goToRegister()}>
                                <a>{t('defaults.login.Register')}</a>
                            </div>*/}

                        </div>

                        <div className={'leumit-login-form-group loginError red h-centered'}>
                            <Error isNonFloat={true}
                                   errorMessage={t('defaults.Registration.reg_err') + ': ' + this.state.errMessage}
                                   isShown={this.state.isErr}/>
                        </div>

                    </div>

                </div>


                <div className={'login-version-element'}>
                        <div className={'login-version-element-label'}>Version:</div>
                        <div className={'login-version-element-value'}>{Config.version} {Config.build}</div>
                    </div>
                <div className={'recaptcha-block'}>
                    <ReCaptcha setRef={ref => (this.recaptchaRef = ref)}
                               action={async (reCaptchaToken) => {
                                   await this.submitData(reCaptchaToken);
                               }}
                        /*setErr={ this.setRecapchaErrors()}*//>
                </div>

            </div>

        )
    }
}

let Login = compose(
    withTranslation()
)(LoginComposed)
export default Login;
